import type { PointOfInterest } from "../types";
import { Marker, Popup } from "./MapCanvas";
import { POI_COLORS, POI_ICONS } from "../constants";

/** Circular POI markers colored by category; the selected one gets a dark
 * border. Feed it the deduped list from `usePoiLayer`. */
export function PoiMarkers({
  pois,
  selectedPoi,
  onSelect,
}: {
  pois: PointOfInterest[];
  selectedPoi: PointOfInterest | null;
  onSelect: (poi: PointOfInterest) => void;
}) {
  return (
    <>
      {pois.map((poi) => {
        const IconComp = POI_ICONS[poi.category];
        const color = POI_COLORS[poi.category];
        const isSelected = selectedPoi?.id === poi.id;
        return (
          <Marker
            key={`poi-${poi.id}`}
            longitude={poi.lng}
            latitude={poi.lat}
            anchor="center"
            onClick={(e) => {
              e.originalEvent.stopPropagation();
              onSelect(poi);
            }}
            style={{ cursor: "pointer", zIndex: 1 }}
          >
            <div
              title={poi.name}
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: color,
                border: isSelected ? "3px solid #1A1814" : "2px solid white",
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconComp className="w-5 h-5" style={{ color: "white" }} />
            </div>
          </Marker>
        );
      })}
    </>
  );
}

/** Detail popup for the selected POI. */
export function PoiPopup({
  poi,
  onClose,
  noDescriptionText = "Sem descrição",
}: {
  poi: PointOfInterest;
  onClose: () => void;
  noDescriptionText?: string;
}) {
  return (
    <Popup
      longitude={poi.lng}
      latitude={poi.lat}
      anchor="bottom"
      onClose={onClose}
      closeButton
      closeOnClick={false}
      focusAfterOpen={false}
      offset={20}
      maxWidth="280px"
      className="poi-detail-popup"
    >
      <div className="min-w-[180px]">
        <p className="font-semibold text-sm text-[#1A1814] mb-1.5 pr-1">
          {poi.name}
        </p>
        {poi.description ? (
          <p className="text-xs text-[#78736D] leading-relaxed pr-1">
            {poi.description}
          </p>
        ) : (
          <p className="text-xs text-[#9E9A94] italic pr-1">
            {noDescriptionText}
          </p>
        )}
      </div>
    </Popup>
  );
}
